import { useProjectContext } from "../contexts/ProjectContext";

export function EmbedButton() {
  const { project, isPreviewMode } = useProjectContext();

  const handleClick = () => {
    if (project?.id) {
      // If it's an unsaved project, just go to the main canvas
      let projectUrl = project.id === 'unsaved-project' 
        ? '/' 
        : `/projects/${project.id}`;
      
      // Add preview token if available
      if (isPreviewMode && project.settings?.preview) {
        projectUrl += `?preview=${project.settings.preview}`;
      }
      
      // Open in a new tab
      window.open(projectUrl, '_blank');
    }
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-2 left-2 flex items-center gap-2 bg-white dark:bg-gray-800 rounded-md px-1 py-1 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
    >
      <img src="/assets/architect-icon.svg" alt="MetaRouter Architect" className="w-4 h-4" />
      <span className="text-gray-900 text-xs dark:text-white">MetaRouter Architect</span>
    </button>
  );
}
